import { defineDialog } from 'best-modules/plugins'
import { dialogComponents, DialogName } from './dialog'
const { DialogPlugin, dialogKey, openDialog } =
  defineDialog<DialogName>(dialogComponents)

export default DialogPlugin

export { dialogKey, openDialog }
